import { User } from "@auth0/auth0-react";
import { auth0Config } from "../../Config/auth0Conifg";

export default function isAdmin(user: User | undefined) {
  return user && user[auth0Config.audience + "/roles"].includes("Admin");
}
